import React, { useState, useEffect } from "react";
import { getUnitOptions } from "../utils/utils";
import SpecManagerInput from "./SpecManagerInput";
import SpecManagerSelect from "./SpecManagerSelect";

export default function SpecsQualitative({
  specValues,
  unitOptions,
  isNewQualitative = false,
  onChange,
}) {
  const units = getUnitOptions(unitOptions);
  const [boundType, , unitValue] = specValues;
  const [qualNumber, setQualNumber] = useState(() => {
    if (isNewQualitative) return "25";
    if (specValues[1]) return specValues[1].replace("/", "");
    return "";
  });

  useEffect(() => {
    if (isNewQualitative) {
      onChange([boundType || "Negative", qualNumber, unitValue]);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleNumberChange = (value) => {
    setQualNumber(value);
    onChange([boundType || "Negative", value, unitValue]);
  };

  return (
    <div className="SpecManager_SpecInputRow">
      <span className="SpecManager_QualitativeLabel">Negative</span>
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--value">
        <SpecManagerInput
          placeholder="eg: 27"
          value={qualNumber}
          onChange={handleNumberChange}
        />
      </div>
      <div className="SpecManager_SpecInputRowCell SpecManager_SpecInputRowCell--unit">
        <SpecManagerSelect
          options={units}
          selectedValue={unitValue || "None"}
          onSelect={(selected) => onChange([boundType || "Negative", qualNumber, selected])}
        />
      </div>
    </div>
  );
}
